export interface IKeypadControlsView {
    disableForeverTurboCheckbox(): void;

    playTransitionToFreeSpins(): void;

    playTransitionToMainGame(): void;

    enableAutoplayButton(): void;

    disableAutoplayButton(): void;

    disableForeverAutoplayButton(): void;

    enableInfoButton(): void;

    enableTurboCheckbox(): void;

    enableBetButtons(): void;

    disableInfoButton(): void;

    disableTurboCheckbox(): void;

    disableBetButtons(): void;

    enableBetIncButton(): void;

    disableBetIncButton(): void;

    enableBetDecButton(): void;

    disableBetDecButton(): void;

    enableMenuButton(): void;

    disableMenuButton(): void;

    enableHomeButton(): void;

    disableHomeButton(): void;

    enableTotalBetOpenButton(): void;

    disableTotalBetOpenButton(): void;

    setBetValueText(text: string): void;

    updateTurboCheckbox(isOn: boolean): void;
}
